/**
 * Types of biometric authentication available
 */
export var BiometryType;
(function (BiometryType) {
    /** Fingerprint scanner */
    BiometryType["FINGERPRINT"] = "fingerprint";
    /** Apple Face ID */
    BiometryType["FACE_ID"] = "faceId";
    /** Apple Touch ID */
    BiometryType["TOUCH_ID"] = "touchId";
    /** Iris scanner */
    BiometryType["IRIS"] = "iris";
    /** Generic face authentication (Android) */
    BiometryType["FACE_AUTHENTICATION"] = "faceAuthentication";
    /** Multiple biometric types available */
    BiometryType["MULTIPLE"] = "multiple";
    /** Passcode/PIN fallback */
    BiometryType["PASSCODE"] = "passcode";
    /** Pattern lock (Android) */
    BiometryType["PATTERN"] = "pattern";
    /** PIN code */
    BiometryType["PIN"] = "pin";
    /** Unknown biometric type */
    BiometryType["UNKNOWN"] = "unknown";
})(BiometryType || (BiometryType = {}));
//# sourceMappingURL=results.js.map